module.exports = __webpack_public_path__ + "img/smarax-log.2e5b09f5.png";